module.exports = __webpack_public_path__ + "img/language.616164dd.png";